import React from "react";
import { Card } from "primereact/card";

const TransactionItem = ({ transaction }) => {
  const isFree =
    transaction?.status === "Free" || transaction?.chargedAmount === "Free";

  return (
    <Card
      className="mb-3 shadow-1 border-round-lg"
      style={{
        borderLeft: `4px solid ${isFree ? "#22c55e" : "#3b82f6"}`,
      }}
    >
      <div className="flex justify-content-between align-items-center gap-3">
        <div className="flex flex-column gap-2 flex-1 min-w-0">
          <div className="flex align-items-center gap-2 flex-wrap">
            <span className="text-xl font-bold text-900">
              Transaction #{transaction?.transactionId}
            </span>
          </div>
          <div className="text-sm text-500">
            <i className="pi pi-calendar mr-1" />
            {transaction?.date}
            {transaction?.timezone && (
              <span className="text-400 ml-1">({transaction.timezone})</span>
            )}
          </div>

          <div className="flex flex-wrap gap-3 text-sm text-600">
            <span>
              <i className="pi pi-clock mr-1 text-400" />
              {transaction?.chargeDuration}
            </span>
            <span>
              <i className="pi pi-bolt mr-1 text-400" />
              {transaction?.energy}
            </span>
            <span>
              <i className="pi pi-map-marker mr-1 text-400" />
              {transaction?.chargingstationName}
            </span>
          </div>
        </div>

        <div className="flex-shrink-0 flex flex-column align-items-end gap-1">
          {isFree ? (
            <span className="text-green-500 font-bold text-xl">Free</span>
          ) : (
            <>
              <span className="font-bold text-xl text-900">
                {transaction?.chargedAmount}
              </span>
              <span className="text-sm text-500">
                incl. fee: {transaction?.chargedAmountWithFee}
              </span>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export default TransactionItem;
